import pkgJson from "../package.json" with { type: "json" };

/** Kept in step with package.json; recorded in every bundle manifest. */
export const VERSION = pkgJson.version;
